export const roundTypeOptions = [
  {
    id: 1,
    name: 'Equity - Priced Round',
    value: 'Equity - Priced Round',
  },
  {
    id: 2,
    name: 'Convertible Note',
    value: 'Convertible Note',
  },
  {
    id: 3,
    name: 'Loan (Debt)',
    value: 'Loan (Debt)',
  },
  {
    id: 4,
    name: 'SAFE',
    value: 'SAFE',
  },
  {
    id: 5,
    name: 'SAFT',
    value: 'SAFT',
  },
]

export const RolesConst = [
  {id: 6, name: 'ADMIN', value: 'admin'},
  {id: 7, name: 'Billing Manager', value: 'billing'},
  {id: 8, name: 'Investor Relationship Manager', value: 'irm'},
  {id: 9, name: 'Fund Raise Manager', value: 'frm'},
  {id: 10, name: 'Investor Curator', value: 'curator'},
  {id: 11, name: 'Super Admin (Owner)', value: 'owner'},
]

// export const plans = [
//   {
//     title: 'Basic',
//     curreny: 'INR',
//     priceMonthINR: '0.00',
//     priceAnnualINR: '0.00',
//     priceMonthUSD: '0.00',
//     priceAnnualUSD: '0.00',
//     custom: false,
//     features: [
//       {
//         title: 'Add Upto 10 investors to CRM funnel',
//         supported: true,
//       },
//       {
//         title: 'Raise up to 1 rounds of funding',
//         supported: true,
//       },
//       {
//         title: 'Create your company page',
//         supported: true,
//       },
//       {
//         title: 'Add upto 1 team member',
//         supported: true,
//       },
//       {
//         title: 'Create Investor Updates',
//         supported: false,
//       },
//       {
//         title: 'Pitch Deck Hosting',
//         supported: false,
//       },
//       {
//         title: 'Send unlimited Emails',
//         supported: false,
//       },

//       {
//         title: 'Data import',
//         supported: false,
//       },
//       {
//         title: 'Data Export',
//         supported: false,
//       },
//       {
//         title: 'BCC Tracking',
//         supported: false,
//       },
//       {
//         title: 'Create upto 0 data room',
//         supported: false,
//       },
//       {
//         title: 'Data room allows uploads of up to 0 MB',
//         supported: false,
//       },
//       {
//         title: 'Upload upto 0 document in digital signing',
//         supported: false,
//       },
//       {
//         title: 'Shared email inbox access',
//         supported: false,
//       },
//       {
//         title: 'Shared calendar access',
//         supported: false,
//       },
//       {
//         title: 'Shared contacts access',
//         supported: false,
//       },
//       {
//         title: 'Ask upto 0 question by Investment Banker AI',
//         supported: false,
//       },
//     ],
//   },
//   {
//     title: 'Silver',
//     curreny: 'INR',
//     priceMonthINR: '7,999.00',
//     priceAnnualINR: '7,9990.00',
//     priceMonthUSD: '99.00',
//     priceAnnualUSD: '990.00',
//     custom: false,
//     label: '',
//     features: [
//       {
//         title: 'Add Upto 30 investors to CRM funnel',
//         supported: true,
//       },
//       {
//         title: 'Raise up to 2 rounds of funding',
//         supported: true,
//       },
//       {
//         title: 'Create Investor Updates',
//         supported: true,
//       },
//       {
//         title: 'Pitch Deck Hosting',
//         supported: true,
//       },

//       {
//         title: 'Send unlimited Emails',
//         supported: true,
//       },
//       {
//         title: 'View upto 50 investors profile',
//         supported: true,
//       },
//       {
//         title: 'Create your company page',
//         supported: true,
//       },
//       {
//         title: 'Add up to 3 team members',
//         supported: true,
//       },
//       {
//         title: 'Data import',
//         supported: true,
//       },

//       {
//         title: 'BCC Tracking',
//         supported: true,
//       },
//       {
//         title: 'Create upto 3 data room',
//         supported: true,
//       },
//       {
//         title: 'Data room allows uploads of up to 500 MB',
//         supported: true,
//       },
//       {
//         title: 'Upload upto 5 documents in digital signing',
//         supported: true,
//       },
//       {
//         title: 'Shared email inbox access',
//         supported: true,
//       },
//       {
//         title: 'Shared calendar access',
//         supported: true,
//       },
//       {
//         title: 'Shared contacts access',
//         supported: true,
//       },
//       {
//         title: 'Ask upto 50 questions by Investment Banker AI',
//         supported: true,
//       },
//       {
//         title: 'Data Export',
//         supported: false,
//       },
//     ],
//   },
//   {
//     title: 'Gold',
//     curreny: 'INR',
//     priceMonthINR: '15,990.00',
//     priceAnnualINR: '15,9900.00',
//     priceMonthUSD: '199.00',
//     priceAnnualUSD: '1990.00',
//     custom: false,
//     label: 'Popular',
//     features: [
//       {
//         title: 'Add Upto 200 investors to CRM funnel',
//         supported: true,
//       },
//       {
//         title: 'Raise up to 8 rounds of funding',
//         supported: true,
//       },
//       {
//         title: 'Create Investor Updates',
//         supported: true,
//       },
//       {
//         title: 'Pitch Deck Hosting',
//         supported: true,
//       },

//       {
//         title: 'Send unlimited Emails',
//         supported: true,
//       },
//       {
//         title: 'View upto 200 investors profile',
//         supported: true,
//       },
//       {
//         title: 'Create your company page',
//         supported: true,
//       },
//       {
//         title: 'Add up to 10 team members',
//         supported: true,
//       },
//       {
//         title: 'Data import',
//         supported: true,
//       },
//       {
//         title: 'Data Export',
//         supported: true,
//       },
//       {
//         title: 'BCC tracking',
//         supported: true,
//       },
//       {
//         title: 'Create upto 10 data room',
//         supported: true,
//       },
//       {
//         title: 'Data room allows uploads of up to 2GB',
//         supported: true,
//       },
//       {
//         title: 'Upload upto 25 documents in digital signing',
//         supported: true,
//       },
//       {
//         title: 'Shared email inbox access',
//         supported: true,
//       },
//       {
//         title: 'Shared calendar access',
//         supported: true,
//       },
//       {
//         title: 'Shared contacts access',
//         supported: true,
//       },
//       {
//         title: 'Ask upto 200 questions by Investment Banker AI',
//         supported: true,
//       },
//     ],
//   },
//   {
//     title: 'Platinum',
//     curreny: 'INR',
//     priceMonthINR: '39,990.00',
//     priceAnnualINR: '39,9900.00',
//     priceMonthUSD: '499.00',
//     priceAnnualUSD: '4,990.00',
//     custom: false,
//     label: 'Recommended',
//     features: [
//       {
//         title: 'Add Upto 500 investors to CRM funnel',
//         supported: true,
//       },
//       {
//         title: 'Raise up to 15 rounds of funding',
//         supported: true,
//       },
//       {
//         title: 'Create Investor Updates',
//         supported: true,
//       },
//       {
//         title: 'Pitch Deck Hosting',
//         supported: true,
//       },

//       {
//         title: 'Send unlimited Emails',
//         supported: true,
//       },
//       {
//         title: 'View upto 500 investors profile',
//         supported: true,
//       },
//       {
//         title: 'Create your company page',
//         supported: true,
//       },
//       {
//         title: 'Add up to 20 team members',
//         supported: true,
//       },
//       {
//         title: 'Data import',
//         supported: true,
//       },
//       {
//         title: 'Data Export',
//         supported: true,
//       },
//       {
//         title: 'BCC tracking',
//         supported: true,
//       },
//       {
//         title: 'Create upto 50 data room',
//         supported: true,
//       },
//       {
//         title: 'Data room allows uploads of up to 10GB',
//         supported: true,
//       },
//       {
//         title: 'Upload upto 100 documents in digital signing',
//         supported: true,
//       },
//       {
//         title: 'Shared email inbox access',
//         supported: true,
//       },
//       {
//         title: 'Shared calendar access',
//         supported: true,
//       },
//       {
//         title: 'Shared contacts access',
//         supported: true,
//       },
//       {
//         title: 'Ask upto 1000 questions by Investment Banker AI',
//         supported: true,
//       },
//     ],
//   },
// ]

// export const plansRK = [
//   {
//     title: 'Basic',
//     curreny: 'INR',
//     priceMonthINR: '0.00',
//     priceAnnualINR: '0.00',
//     priceMonthUSD: '0.00',
//     priceAnnualUSD: '0.00',
//     custom: false,
//     features: [
//       {
//         title: '100 MB Storage',
//         supported: true,
//       },
//       {
//         title: '500 AI Search and Retrievals',
//         supported: true,
//       },
//       {
//         title: '100 File Processing',
//         supported: true,
//       },
//       {
//         title: 'Add upto 1 Team Member',
//         supported: true,
//       },
//       {
//         title: 'Company Page',
//         supported: true,
//       },
//       {
//         title: 'Support',
//         supported: true,
//       },
//       {
//         title: 'Training Hub',
//         supported: true,
//       },

//       {
//         title: 'Data Rooms',
//         supported: false,
//       },
//       {
//         title: 'Compliance Meeting',
//         supported: false,
//       },
//       {
//         title: 'Cap Table Management',
//         supported: false,
//       },
//       {
//         title: 'Digital Signing',
//         supported: false,
//       },
//       {
//         title: 'Shared Inbox, Calendar, & Contacts',
//         supported: false,
//       },
//       {
//         title: 'Data export',
//         supported: false,
//       },
//       {
//         title: 'Bulk Import',
//         supported: false,
//       },
//     ],
//   },
//   {
//     title: 'Silver',
//     curreny: 'INR',
//     priceMonthINR: '7,999.00',
//     priceAnnualINR: '7,9990.00',
//     priceMonthUSD: '99.00',
//     priceAnnualUSD: '990.00',
//     custom: false,
//     label: '',
//     features: [
//       {
//         title: '1 GB Storage',
//         supported: true,
//       },
//       {
//         title: '5000 AI Search and Retrievals',
//         supported: true,
//       },
//       {
//         title: '1000 File Processing',
//         supported: true,
//       },
//       {
//         title: 'Add upto 3 Team Members',
//         supported: true,
//       },

//       {
//         title: 'Create 3 Data Rooms',
//         supported: true,
//       },
//       {
//         title: 'Create 10 Compliance Meetings',
//         supported: true,
//       },
//       {
//         title: 'Cap Table Management',
//         supported: true,
//       },
//       {
//         title: '5 Documents Signing',
//         supported: true,
//       },
//       {
//         title: 'Shared Inbox, Calendar, & Contacts',
//         supported: true,
//       },

//       {
//         title: 'Company Page',
//         supported: true,
//       },
//       {
//         title: 'Bulk Import',
//         supported: true,
//       },
//       {
//         title: 'Support',
//         supported: true,
//       },
//       {
//         title: 'Training Hub',
//         supported: true,
//       },
//       {
//         title: 'Data export',
//         supported: false,
//       },
//     ],
//   },
//   {
//     title: 'Gold',
//     curreny: 'INR',
//     priceMonthINR: '15,990.00',
//     priceAnnualINR: '15,9900.00',
//     priceMonthUSD: '199.00',
//     priceAnnualUSD: '1990.00',
//     custom: false,
//     label: 'Popular',
//     features: [
//       {
//         title: '10 GB Storage',
//         supported: true,
//       },
//       {
//         title: '10k AI Search and Retrievals',
//         supported: true,
//       },
//       {
//         title: '50k File Processing',
//         supported: true,
//       },
//       {
//         title: 'Add upto 10 Team Members',
//         supported: true,
//       },

//       {
//         title: 'Create 10 Data Rooms',
//         supported: true,
//       },
//       {
//         title: 'Create 25 Compliance Meetings',
//         supported: true,
//       },
//       {
//         title: 'Cap Table Management',
//         supported: true,
//       },
//       {
//         title: '20 Documents Signing',
//         supported: true,
//       },
//       {
//         title: 'Shared Inbox, Calendar, & Contacts',
//         supported: true,
//       },
//       {
//         title: 'Company Page',
//         supported: true,
//       },
//       {
//         title: 'Bulk Import',
//         supported: true,
//       },
//       {
//         title: 'Support',
//         supported: true,
//       },
//       {
//         title: 'Training Hub',
//         supported: true,
//       },
//       {
//         title: 'Data Export',
//         supported: true,
//       },
//     ],
//   },
//   {
//     title: 'Platinum',
//     curreny: 'INR',
//     priceMonthINR: '39,990.00',
//     priceAnnualINR: '39,9900.00',
//     priceMonthUSD: '499.00',
//     priceAnnualUSD: '4,990.00',
//     custom: false,
//     label: 'Recommended',
//     features: [
//       {
//         title: '50 GB Storage',
//         supported: true,
//       },
//       {
//         title: '50k AI Search and Retrievals',
//         supported: true,
//       },
//       {
//         title: '500k File Processing',
//         supported: true,
//       },
//       {
//         title: 'Add upto 20 Team Members',
//         supported: true,
//       },

//       {
//         title: 'Create 50 Data Rooms',
//         supported: true,
//       },
//       {
//         title: 'Create 60 Compliance Meetings',
//         supported: true,
//       },
//       {
//         title: 'Cap Table Management',
//         supported: true,
//       },
//       {
//         title: '100 Documents Signing',
//         supported: true,
//       },
//       {
//         title: 'Shared Inbox, Calendar, & Contacts',
//         supported: true,
//       },
//       {
//         title: 'Company Page',
//         supported: true,
//       },
//       {
//         title: 'Bulk Import',
//         supported: true,
//       },
//       {
//         title: 'Support',
//         supported: true,
//       },
//       {
//         title: 'Training Hub',
//         supported: true,
//       },
//       {
//         title: 'Data Export',
//         supported: true,
//       },
//     ],
//   },
// ]

export const ipstackDefaultData = {
  ip: '181.214.131.165',
  type: 'ipv4',
  continent_code: 'NA',
  continent_name: 'North America',
  country_code: 'US',
  country_name: 'United States',
  region_code: 'NY',
  region_name: 'New York',
  city: 'Manhattan',
  zip: 10020,
  latitude: 40.7589111328125,
  longitude: -73.97901916503906,
  location: {
    geoname_id: 5125771,
    capital: 'Washington D.C.',
    languages: [
      {
        code: 'en',
        name: 'English',
        native: 'English',
      },
    ],
    country_flag: 'https://assets.ipstack.com/flags/us.svg',
    country_flag_emoji: '🇺🇸',
    country_flag_emoji_unicode: 'U+1F1FA U+1F1F8',
    calling_code: '1',
    is_eu: false,
  },
  time_zone: {
    id: 'America/New_York',
    current_time: '2024-12-27T14:55:26-05:00',
    gmt_offset: -18000,
    code: 'EST',
    is_daylight_saving: false,
  },
  currency: {
    code: 'USD',
    name: 'US Dollar',
    plural: 'US dollars',
    symbol: '$',
    symbol_native: '$',
  },
  connection: {
    asn: 199218,
    isp: 'Proton Ag',
  },
  security: {
    is_proxy: true,
    proxy_type: 'service',
    is_crawler: false,
    crawler_name: null,
    crawler_type: null,
    is_tor: false,
    threat_level: 'low',
    threat_types: null,
  },
}


 export const plansRK = [
    {
      id: 1,
      title: 'Personal',
      subheader: `Best for an individual person's personal use`,
      curreny: 'INR',
      priceMonthINR: '999',
      priceAnnualINR: '9,990',
      priceMonthUSD: '14',
      priceAnnualUSD: '140',
      custom: false,
      features: [
        {
          title: '1 GB Storage',
        },
        {
          title: '200 AI Search and Retrievals',
        },
        {
          title: '1,000 File Processing',
        },
        {
          title: '2 Team Member',
        },
        {
          title: 'Data Export',
        },
        {
          title: 'Bulk Import',
        },
        {
          title: 'Company Page',
        },
        {
          title: 'Support',
        },
      ],
    },
    {
      id: 2,
      title: 'Silver',
      subheader: 'Ideal for small teams & growing businesses',
      curreny: 'INR',
      priceMonthINR: '3,999',
      priceAnnualINR: '39,990',
      priceMonthUSD: '49',
      priceAnnualUSD: '490',
      custom: false,
      label: '',
      features: [
        {
          title: '1 GB Storage',
        },
        {
          title: '500 AI Search and Retrievals',
        },
        {
          title: '1,000 File Processing',
        },
        {
          title: '2 Team Member',
        },
        {
          title: 'Create 3 Data Rooms',
        },
        {
          title: 'Create 10 Compliance Meetings',
        },
        {
          title: 'Cap Table Management',
        },
        {
          title: '5 Documents Signing',
        },
        {
          title: 'Shared Inbox, Calendar, & Contacts',
        },
        {
          title: 'Bulk Import',
        },
        {
          title: 'Company Page',
        },
        {
          title: 'Support',
        },
        {
          title: 'Training Hub',
        },
      ],
    },
    {
      id: 3,
      title: 'Gold',
      subheader: 'Best for mid-sized companies and startups',
      curreny: 'INR',
      priceMonthINR: '7,999',
      priceAnnualINR: '79,990',
      priceMonthUSD: '99',
      priceAnnualUSD: '990',
      custom: false,
      label: 'Popular',
      features: [
        {
          title: '5 GB Storage',
        },
        {
          title: '2,000 AI Search and Retrievals',
        },
        {
          title: '10,000 File Processing',
        },
        {
          title: '5 Team Members',
        },
        {
          title: 'Create 10 Data Rooms',
        },
        {
          title: 'Create 25 Compliance Meetings',
        },
        {
          title: 'Cap Table Management',
        },
        {
          title: '20 Documents Signing',
        },
        {
          title: 'Shared Inbox, Calendar, & Contacts',
        },
        {
          title: 'Bulk Import',
        },
        {
          title: 'Company Page',
        },
        {
          title: 'Support',
        },
        {
          title: 'Training Hub',
        },
        {
          title: 'Data Export',
        },
      ],
    },
    {
      id: 4,
      title: 'Platinum',
      subheader: 'Complete solution for enterprises',
      curreny: 'INR',
      priceMonthINR: '14,999',
      priceAnnualINR: '1,49,990',
      priceMonthUSD: '199',
      priceAnnualUSD: '1,990',
      custom: false,
      label: 'Recommended',
      features: [
        {
          title: '20 GB Storage',
        },
        {
          title: '6,000 AI Search and Retrievals',
        },
        {
          title: '30,000 File Processing',
        },
        {
          title: '10 Team Members',
        },
        {
          title: 'Create 50 Data Rooms',
        },
        {
          title: 'Create 60 Compliance Meetings',
        },
        {
          title: 'Cap Table Management',
        },
        {
          title: '100 Documents Signing',
        },
        {
          title: 'Shared Inbox, Calendar, & Contacts',
        },
        {
          title: 'Bulk Import',
        },
        {
          title: 'Company Page',
        },
        {
          title: 'Support',
        },
        {
          title: 'Training Hub',
        },
        {
          title: 'Data Export',
        },
      ],
    },
  ]

  export const comparision = {
    plans: [
      {
        id: 1,
        title: 'Personal',
        subheader: 'Best for individuals',
      },
      {
        id: 2,
        title: 'Silver',
        subheader: 'Best for small teams',
      },
      {
        id: 3,
        title: 'Gold',
        subheader: 'Best for startups',
      },
      {
        id: 4,
        title: 'Platinum',
        subheader: 'Best for corporations',
      },
      {
        id: 5,
        title: 'Enterprise',
        subheader: 'Built for custom needs',
      },
    ],
    details: [
      {
        availability: ['RecordsKeeper.AI', 'Yes', 'Yes', 'Yes', 'Yes', 'Yes'],
        includes: [
          {
            title: 'RecordsKeeper.AI Storage Limit',
            limits: ['1GB', '1GB', '5GB', '20GB', 'Custom'],
          },
          {
            title: 'File Processing',
            limits: ['1,000', '1,000', '10,000', '30,000', 'Custom'],
          },
          {
            title: 'AI Search and Retrieval',
            limits: ['200', '500', '2,000', '6,000', 'Custom'],
          },
        ],
      },
      {
        availability: ['Stakeholders Management', 'No', 'Yes', 'Yes', 'Yes', 'Yes'],
        includes: [
          {
            title: 'Stakeholders Limit',
            limits: ['-', '25', '60', '100', 'Custom'],
          },
        ],
      },
      {
        availability: ['Data Rooms', 'No', 'Yes', 'Yes', 'Yes', 'Yes'],
        includes: [
          {
            title: 'Number of Data Rooms',
            limits: ['-', '3', '10', '50', 'Custom'],
          },
          {
            title: 'Data Rooms Storage Limit',
            limits: ['-', '500MB', '2GB', '10GB', 'Custom'],
          },
        ],
      },
      {
        availability: ['Compliance Meetings Management', 'No', 'Yes', 'Yes', 'Yes', 'Yes'],
        includes: [
          {
            title: 'Number of Board Meetings',
            limits: ['-', '10', '25', '60', 'Custom'],
          },
          {
            title: 'Access to Shareholders Meeting Management',
            limits: ['No', 'Yes', 'Yes', 'Yes', 'Yes'],
          },
          {
            title: 'Number of Shareholders Meetings',
            limits: ['-', '5', '15', '30', 'Custom'],
          },
          {
            title: 'Automatic Minutes of Meeting Generation',
            limits: ['No', 'No', 'Yes', 'Yes', 'Yes'],
          },
        ],
      },
      {
        availability: ['Cap Table Management', 'No', 'Yes', 'Yes', 'Yes', 'Yes'],
        includes: [
          {
            title: 'Captable Projections',
            limits: ['No', 'Yes', 'Yes', 'Yes', 'Yes'],
          },
          {
            title: 'Historic Captable',
            limits: ['No', 'Yes', 'Yes', 'Yes', 'Yes'],
          },
          {
            title: 'Captable Simulation',
            limits: ['No', 'Yes', 'Yes', 'Yes', 'Yes'],
          },
        ],
      },
      {
        availability: ['Digital Signing', 'No', 'Yes', 'Yes', 'Yes', 'Yes'],
        includes: [
          {
            title: 'Documents Limit',
            limits: ['-', '5', '25', '100', 'Custom'],
          },
        ],
      },
      {
        availability: ['Shared Access', 'No', 'Yes', 'Yes', 'Yes', 'Yes'],
        includes: [
          {
            title: 'Email Integration',
            limits: ['No', 'Yes', 'Yes', 'Yes', 'Yes'],
          },
          {
            title: 'Shared Email Inbox',
            limits: ['No', 'Yes', 'Yes', 'Yes', 'Yes'],
          },
          {
            title: 'Shared Calendar',
            limits: ['No', 'Yes', 'Yes', 'Yes', 'Yes'],
          },
          {
            title: 'Automatic Meeting Links',
            limits: ['No', 'Yes', 'Yes', 'Yes', 'Yes'],
          },
          {
            title: 'Shared Contacts',
            limits: ['No', 'Yes', 'Yes', 'Yes', 'Yes'],
          },
          {
            title: 'AI Helper for Communication',
            limits: ['No', 'Yes', 'Yes', 'Yes', 'Yes'],
          },
        ],
      },
      {
        availability: ['Training Hub', 'Yes', 'Yes', 'Yes', 'Yes', 'Yes'],
      },
      {
        availability: ['Others', 'Yes', 'Yes', 'Yes', 'Yes', 'Yes'],
        includes: [
          {
            title: 'Data Export',
            limits: ['Yes', 'No', 'Yes', 'Yes', 'Yes'],
          },
          {
            title: 'Bulk Import',
            limits: ['Yes', 'Yes', 'Yes', 'Yes', 'Yes'],
          },
          {
            title: 'Team Members',
            limits: ['2', '2', '5', '10', 'Custom'],
          },
        ],
      },
      {
        availability: ['Support', 'Yes', 'Yes', 'Yes', 'Yes', 'Yes'],
        includes: [
          {
            title: 'Access to Help Center',
            limits: ['Yes', 'Yes', 'Yes', 'Yes', 'Yes'],
          },
          {
            title: 'Email support',
            limits: ['Yes', 'Yes', 'Yes', 'Yes', 'Yes'],
          },
          {
            title: 'Chat Support',
            limits: ['No', 'Yes', 'Yes', 'Yes', 'Yes'],
          },
          {
            title: 'Video Call Support',
            limits: ['No', 'No', 'Yes', 'Yes', 'Yes'],
          },
        ],
      },
    ],
  }